<template>
  <Dialog
    :visible="true"
    modal
    :closable="false"
    :dismissableMask="false"
    :header="t('profile.notifications.setup.title')"
    :style="{ width: '600px' }"
  >
    <p class="text-color-secondary mb-6">{{ t('profile.notifications.setup.description') }}</p>

    <NotificationPreferencesForm
      v-model:assessmentProjects="enabledAssessmentProjects"
      v-model:regulationWatchProjects="enabledRegulationWatchProjects"
    />

    <template #footer>
      <Button
        :label="t('profile.notifications.setup.save')"
        icon="pi pi-check"
        :loading="isSaving"
        @click="savePreferences"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { useUsersStore } from '@/stores/users'
import NotificationPreferencesForm from '@/components/shared/NotificationPreferencesForm.vue'

const { t } = useI18n()

const usersStore = useUsersStore()

const isSaving = ref(false)

// Local state — the assessment emails start empty (no pre-selection); the watch
// report starts from what is stored, so the answer given in the welcome letter
// (MYAC-1522, decision C) is shown and kept, never wiped by this save.
const enabledAssessmentProjects = ref<string[]>([])
const enabledRegulationWatchProjects = ref<string[]>([...(usersStore.notificationPreferences?.regulation_watch_projects ?? [])])

async function savePreferences() {
  isSaving.value = true
  try {
    await usersStore.updateNotificationPreferences({
      assessment_completed_projects: enabledAssessmentProjects.value,
      regulation_watch_projects: enabledRegulationWatchProjects.value,
      notification_setup_completed: true,
    })
  } finally {
    isSaving.value = false
  }
}
</script>
